import styled from 'styled-components';

export const Spinner = styled.div`
  background: conic-gradient(transparent, #022d58);
  width: 75px;
  height: 75px;
  animation: spin 2s linear infinite;
  border-radius: 50%;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    width: 55px;
    height: 55px;
    background-color: #fff;
    right: 10px;
    top: 10px;
    border-radius: 50%;
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
